module.exports = __webpack_public_path__ + "img/COPY.f0e8cf7d.svg";